module.exports = __webpack_public_path__ + "static/img/MA_1920_ru_awards1.ae706db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MA_1920_ru_awards1.jpg
// module id = QqA+
// module chunks = 1